import axios from 'axios'
import util from './index'
const rules = {
    userName: [
        { required: true, message: '登录账号为手机号'},
        { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码格式不正确', trigger: 'blur'},
        { validator: checkUserName, trigger: 'blur'}
    ],
    loginName: [
        { required: true, message: '请输入登录账号'}
    ],
    verificationCode:[{ required: true, message: '请输入验证码'}],
    fpassword: [
        {required: true, message: '请输入登录密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
    ],
    fenPassword: [
        {required: true, message: '请再次输入登录密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
    ],
    registerStatusName: [
        {required: true}
    ],
    supplierStatusName: [
        {required: true}
    ],
    companyName: [
        { required: true, message: '请输入企业名称'}
    ],
    taxipayerStatus: [
        { required: true, message: '请选择纳税人状态', trigger: 'change'}
    ],
    // responser
   /* socialCreditCode:[
        {required: true, message: '必填项'},
        { validator: 'regexp',pattern: /^[0-9a-zA-Z]{18}$/,trigger: 'blur' }
        ],
    businessLicenseNumber:[
        {required: true, message: '必填项'},
        { validator: 'regexp',pattern: /^[a-zA-Z0-9]{13,15}$/,trigger: 'blur' }
        ],*/
    taxCertificateNumber:[
        {required: true, message: '请输入税务登记证号'}
        ],
    orgCertificateNumber:[
        {required: true, message: '请输入组织机构代码证号'}
        ],
    intentionRegionalCompanyIds:[
        {required: true, message: '请选择意向地区公司'}
    ],
    undertakeAreas: [
        {required: true, message: '请选择可承接省份'}
    ],
    supplierServiceCategoryIds:[
        {required: true, message: '请选择供方服务类别', trigger: 'change'}
    ],
    supplierCategoryIds:[
        {required: true, message: '请选择供方分类', trigger: 'change'}
    ],
    headquartersAddress:[
        {required: true, message: '请输入总部具体地址'}
    ],
    enterpriseCharacterize:[
        {required: true, message: '请选择企业性质'}
    ],
    enterpriseCharacterizeRemark:[
        {required: true, message: '请输入“其他”，相关说明'}
    ],
    enterpriseRegistAddress:[
        {required: true, message: '请输入企业注册地址'}
    ],
    enterpriseRegistrationYear:[
        {required: true, message: '请选择企业成立日期', trigger: 'change'},
    ],
    officeArea:[
        // {required: false,validator: 'regexp', pattern: /^\d*$/,message: '办公面积必须为数字值'}
        {type: 'number', message: '办公面积必须为数字值'}
    ],
    legalRepresentative:[
        {required: true, message: '请输入法定代表人'}
    ],
    legalRepresentativeIdNumber:[
        {required: false, message: '请输入法定代表人身份证号'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确', trigger: 'blur'}
    ],
    registeredCapital:[
        {required: true, message: '请输入注册资本'},
        { type: 'number', message: '注册资本必须为数字值',trigger: 'blur'}
    ],
    qualificationName: [
        {required: true, message: '请输入资质名称'}
    ],
    certificateNumber:[
        {required: true, message: '请输入资质证书编号'}
    ],
    validityPeriod:[
        {required: true, message: '请选择资质证书有效期'}
    ],
    stockholderName:[
        {required: true, message: '请输入股东姓名'}
    ],
    stockholderCreditNumber:[
        {required: false, message: '请输入股东身份证号'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确',trigger: 'blur'}
    ],
    contactName:[
        {required: true, message: '请输入联系人姓名'}
    ],
    mobile:[
        {required: true, message: '请输入联系人手机'},
        { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码格式不正确', trigger: 'blur'}
    ],
    email:[
        {required: true, message: '请输入联系人电子邮件'},
        { validator: 'regexp',pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,message:'邮箱格式不正确',trigger:'blur'}
    ],
    creditNumber:[
        {required: false, message: '请输入联系人身份证号'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确', trigger: 'blur'}
    ],
    positionName:[
        {required: true, message: '请输入联系人职位'}
    ],
    recommenderType:[
        {required: true, message: '请选择推荐人类型'}
    ],
    recommenderName:[
        {required: true, message: '请输入推荐人'}
    ],
    recommenderUnit:[
        {required: true, message: '请输入推荐人单位'}
    ],
    recommenderPhone:[
        {required: true, message: '请输入推荐人联系电话'},
        { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码格式不正确', trigger: 'blur'}
    ],
    recommenderIllustration:[
        {required: true, message: '请输入推荐人说明'}
    ],
    hasRelateParentCompany: [
        { required: true, message: '请选择有无关联母公司' }
    ],
    relateParentCompanyId:[
        {required: true, message: '请选择关联母公司名称'}
    ],
    mainBusinessAreaIds:[
        {required: true, message: '请输入主要业务区域'}
    ],
    lastYearSales:[
        {required: true, message: '请输入上年营业额'},
        { type: 'number', message: '营业额必须为数字值',trigger: 'blur'}
    ],
    fileList: [
        { required: true, message: '附件不能为空'}
    ],
    //新增字段：
    headquartersProvince:[//所在区域
        {required: true, message: '请选择所在区域',validator: checkArea}
    ],
    companyListed:[//是否上市公司
        {required: true, message: '请选择是否上市公司'}
    ],
    staffNumbers:[//员工总数
        {required: true, message: '请输入员工总数'},
        { type: 'number', message: '员工总数必须为数字值',trigger: 'blur'}
    ],
    fullMemberFlag:[//是否全装联会员
        {required: true, message: '请选择是否全装联会员'}
    ],
    cooperationAmount: [//合作额度
        { required: false,validator: checkDeg}
    ],
    /* 单位银行信息 Start */
    accountNo: [{
        required: true,
        message: '请输入银行银行号',
    }, {
        validator: 'regexp',
        pattern: /^(\d){9}(\d)*$/,
        message: '银行银行号不正确',
    }],
    bankName: [{
        required: true,
        message: '请输入开户银行',
    }],
    accountName: [{
        required: true,
        message: '请输入开户名称',
        trigger: 'blur'
    }],
    bankNo: [{
        required: true,
        message: '请输入银行账号',
    }, {
        validator: 'regexp',
        pattern: /^(\d){9}(\d)*$/,
        message: '银行账号不正确',
    }]
    ,areaCode: [{
        required: true,
        message: '请输入地区代码',
        trigger: 'blur'
    }]
    ,accountType: [{
        required: true,
        message: '请选择币种',
        trigger: ['blur','change']
    }]
    ,areaProvince: [{
        required: true,
        message: '请选择省份',
        trigger: ['blur','change']
    }]
    ,areaCity: [{
        required: true,
        message: '请选择市县',
        trigger: ['blur','change']
    }],

    /* 单位银行信息 End */
    contractAttachement: [{
        required: true,
        message: '请上传劳动合同证明',
    }],
    secureAttachement: [{
        required: true,
        message: '请上传社保缴费证明',
    }],

    mainIntentionRegionalCompanyId: [{
        required: true,
        message: '请选择服务城市（主）',
    }],
    signTime: [{
        required: true,
        message: '请选择合同签约日期',
    }],
    signContactPrice: [{
        required: true,
        message: '请输入合同额度',
    }],
    lstattachmentVO: [{
        required: true,
        message: '请选择合同附件',
    }],
    /* 业绩信息End */
    creditLicenseAttachments: [{
        required: true,
        message: '请选择营业执照号/统一社会信用代码附件',
    }], // 营业执照号/统一社会信用代码
    // taxCertificateNumberAttachments: [{
    //     required: true,
    //     message: '请选择税务登记证号附件',
    // }], //税务登记证号附件
    // institutionAttachments: [{
    //     required: true,
    //     message: '请选择组织机构代码证号附件',
    // }], // 组织机构代码证号附件
    officeAttachments: [{
        required: true,
        message: '请选择办公环境附件',
    }], //办公环境附件
    taxAttachments: [{
        required: true,
        message: '请选择增值税一般纳税人申请认定表附件',
    }], //增值税一般纳税人申请认定表
    auditAttachments: [{
        required: true,
        message: '请选择上年审计报告或年营业额证明附件',
    }], //上年审计报告或年营业额证明
};
function checkUserName(rule,value,callback){
    axios.get(util.baseUrl+'/v1/sSuppliers/public/checkLoginName/'+value+'/1')
        .then(function (res) {
            // console.log(res);
            if(res.data.code == 1){
                callback();
            } else {
                callback(new Error(res.data.msg));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}
function checkArea(rule,value,callback){
    // console.log(value)
    if(value == ''){
        callback(new Error('请选择所在区域'));
    } else {
        callback();
    }
}
function checkDeg(rule,value,callback){
    // console.log(value)
    // let reg = /^(-?\d+)(\.\d+)?$/;
    let reg = /^\d+(\.\d{1,2})?$/;
    if(!value){
        callback();
    } else if(!reg.test(value)) {
        callback(new Error('请输入数字，且小数点后不超过两位'));
    } else {
        callback();
    }
}
/*function checkSocialCode(rule,value,callback){

    axios.post(util.baseUrl+'/v1/sSuppliers/public/checkCodeOrNumber',{
        "businessLicenseNumber": "",
        "creditLicenseCodeFlag": 1,
        "socialCreditCode": value,
        "supplierId": ''
    })
        .then(function (res) {
            console.log(res);
            if(res.data.code == 2){
                callback();
            } else {
                callback(new Error(res.data.msg));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}*/

let registerRules = {} //注册页面注册信息及企业信息验证
__rules_generator(registerRules, ['creditLicenseAttachments', 
// 'taxCertificateNumberAttachments', 
// 'institutionAttachments', 
'officeAttachments', 'taxAttachments', 'auditAttachments',
            'taxipayerStatus', 'taxCertificateNumber', 'orgCertificateNumber',
            'mainIntentionRegionalCompanyId', 'intentionRegionalCompanyIdsArr',
    'companyName', 'supplierServiceCategoryIds', 'supplierCategoryIds', 'headquartersAddress', 'enterpriseCharacterize', 'enterpriseCharacterizeRemark', 'enterpriseRegistAddress', 'enterpriseRegistrationYear', 'officeArea', 'legalRepresentative', 'registeredCapital', 'headquartersProvince', 'staffNumbers', 'fullMemberFlag', 'undertakeAreas'
], rules)
let naturalRules = {}//资质等级验证
__rules_generator(naturalRules, ['qualificationName','certificateNumber','validityPeriod'], rules)
let partnerRules = {}//股东验证
__rules_generator(partnerRules, ['stockholderName','stockholderCreditNumber'], rules)
let contactRules = {}; //联系方式验证
__rules_generator(contactRules, ['contactName', 'mobile', 'email', 'creditNumber', 'positionName', 'secureAttachement', 'contractAttachement'], rules);

let InfoTypeRules = {}//信息类型验证
__rules_generator(InfoTypeRules, ['recommenderType','recommenderName','recommenderUnit','recommenderPhone','recommenderIllustration'], rules)
let affiliateRules = {}//关联母公司验证
__rules_generator(affiliateRules, ['hasRelateParentCompany','relateParentCompanyId'], rules)
let businessRules = {}//业务状况验证
__rules_generator(businessRules, ['mainBusinessAreaIds','lastYearSales'], rules)
let numberRules = {}//近三年业绩验证
__rules_generator(numberRules, ['cooperationAmount'], rules)
let annexRules = {}//附件清單
__rules_generator(annexRules, ['fileList'], rules)
let loginRules = {};//登录界面验证
__rules_generator(loginRules, ['loginName','verificationCode','fpassword'], rules)

let bankRules = {}; //
__rules_generator(bankRules, ['accountNo', 'bankName', 'accountName', 'bankNo', 'areaCode', 'accountType', 'areaProvince', 'areaCity'], rules);

let suppliersAchievenRules = {}; //
__rules_generator(suppliersAchievenRules, ['contactName', 'signTime', 'signContactPrice', 'lstattachmentVO'], rules);

export {
    registerRules,
    naturalRules,
    partnerRules,
    contactRules,
    InfoTypeRules,
    affiliateRules,
    businessRules,
    numberRules,
    annexRules,
    loginRules,
    bankRules,
    suppliersAchievenRules
}

function __rules_generator(obj, keys, rules){
    keys.forEach(k=>{
        return obj[k] = rules[k]
    })
}



// WEBPACK FOOTER //
// ./src/util/rules.js